
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';



import Home from "./components/pages/Home";

import Footer from "./components/inc/Footer";
import Bethuadahari from './components/pages/Bethuadahari';
import WomensWear from './components/pages/WomensWear';
import BarniaShowroom from './components/pages/BarniaShowroom';
import Saree from './components/pages/Saree';
import Menswear from './components/pages/Menswear';
import Kidswear from './components/pages/Kidswear';
import Accessories from './components/pages/Accessories';
import LadiesBag from './components/pages/LadiesBag';
import Contactus from './components/pages/Contactus';
import Churidar from './components/pages/Churidar';
import Womenjeans from './components/pages/Womenjenas';
import Lehenga from './components/pages/Lehenga';
import Womentshirt from './components/pages/Womentshirt';
import Croptop from './components/pages/Croptop';
import Blazer from './components/pages/Blazer';
import MenTshirt from './components/pages/MenTshirt';
import Panjabi from './components/pages/Panjabi';
import MenShirt from './components/pages/MenShirt';
import MenJeans from './components/pages/MenJeans';
import Enquiry from './components/pages/Enquiry';
import Kurti from './components/pages/Kurti';
import KidsTshirt from './components/pages/KidsTshirt';
import KidsBlazer from './components/pages/KidsBlazer';
import KidsPanjabi from './components/pages/KidsPanjabi';
import KidsHalfpant from './components/pages/KidsPant';
import Kidsdress from './components/pages/Kidsdress';
import Trolleybag from './components/pages/Trolleybag';
import Schoolbag from './components/pages/Schoolbag';
import Moneybag from './components/pages/Moneybag';
import KidsFullpant from './components/pages/KidsFullpant';
import Cosmetics from './components/pages/Cosmetics';
import Chandraboti from './components/pages/Chandraboti';
import Kidsfrockpage from './components/pages/Kidsfrockpage';
import Bethua2 from './components/pages/Bethua2';


function App() {
  return (
    <Router>
    
    <div>

     
      
      <Routes>

      <Route axact path="/" element={<Home/>}/>
      <Route axact path="/Bethuadahari-headoffice_showroom" element={<Bethuadahari/>}/>
      <Route axact path="/womens-wear" element={<WomensWear/>}/>
      <Route axact path="/barnia-showroom" element={<BarniaShowroom/>}/>
      <Route axact path="/saree" element={<Saree/>}/>
      <Route axact path="/mens-wear" element={<Menswear/>}/>
      <Route axact path="/kids-wear" element={<Kidswear/>}/>
      <Route axact path="/Accessories" element={<Accessories/>}/>
      <Route axact path="/LadiesBag" element={<LadiesBag/>}/>
      <Route axact path="/Churidar" element={<Churidar/>}/>
      <Route axact path="/jeans" element={<Womenjeans/>}/>
      <Route axact path="/Lehenga" element={<Lehenga/>}/>
      <Route axact path="/t-shirt" element={<Womentshirt/>}/>
      <Route axact path="/top" element={<Croptop/>}/>
      <Route axact path="/kurti" element={<Kurti/>}/>
      <Route axact path="/blazer-men" element={<Blazer/>}/>
      <Route axact path="/men-tshirt" element={<MenTshirt/>}/>
      <Route axact path="/Panjabi" element={<Panjabi/>}/>
      <Route axact path="/Men-shirt" element={<MenShirt/>}/>
      <Route axact path="/men-jeans" element={<MenJeans/>}/>
      <Route axact path="/contact-us" element={<Contactus/>}/>
      <Route axact path="/Enqueries" element={<Enquiry/>}/>
      <Route axact path="/kids_tshirt" element={<KidsTshirt/>}/>
      <Route axact path="/kids_blazer" element={<KidsBlazer/>}/>
      <Route axact path="/kids_panjabi" element={<KidsPanjabi/>}/>
      <Route axact path="/kids_shortpant" element={<KidsHalfpant/>}/>
      <Route axact path="/kids-dress" element={<Kidsdress/>}/>
      <Route axact path="/trolley-bag" element={<Trolleybag/>}/>
      <Route axact path="/school-bag" element={<Schoolbag/>}/>
         <Route axact path="/wallet" element={<Moneybag/>}/>
         <Route axact path="/kids-fullpant" element={<KidsFullpant/>}/>
                  <Route axact path="/Cosmetics" element={<Cosmetics/>}/>
                          <Route axact path="/Chandraboti" element={<Chandraboti/>}/>
                           <Route axact path="/kidsfrock" element={<Kidsfrockpage/>}/>
                              <Route axact path="/Bethuadahari" element={<Bethua2/>}/>
      </Routes>
    <Footer/>
  
    </div>

    </Router>

  );
}

export default App;
